<template>
  <div>
    <Menu 
      @tourChanged="changeTourSource($event)" 
      :mdList="mdList"
    />
    <TourFrame :link="linkStr" />
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import TourFrame from '@/components/TourFrame.vue'

export default {
  data: () => ({
    linkStr: "https://kuula.co/share/7bb4d?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1",
    mdList: [
      {
        url: '7bZtg?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 10,
        name: 'GUAYACÁN 57M2',
        style: {
          bg: 'yellow-1',
          color: 'menu-item-text2'
        }
      },
      {
        url: '7bb4d?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 11,
        name: 'GUAYACÁN 68M2',
        style: {
          bg: 'yellow-1',
          color: 'menu-item-text2'
        }
      },
      {
        url: '7bb5G?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 12,
        name: 'GUAYACÁN 75M2',
        style: {
          bg: 'yellow-1',
          color: 'menu-item-text2'
        }
      },
      {
        url: '7vqw0?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 1,
        name: 'EUCALIPTO 76M2 | KIT FRESCO',
        style: {
          bg: 'purple-1',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqwk?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 2,
        name: 'EUCALIPTO 76M2 | KIT MODERNO',
        style: {
          bg: 'purple-1',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqsQ?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 3,
        name: 'EUCALIPTO 76M2 | KIT CAMPESTRE',
        style: {
          bg: 'purple-1',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqwD?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 4,
        name: 'EUCALIPTO 82M2 | KIT FRESCO',
        style: {
          bg: 'purple-2',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqwn?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 5,
        name: 'EUCALIPTO 82M2 | KIT MODERNO',
        style: {
          bg: 'purple-2',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqwc?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 6,
        name: 'EUCALIPTO 82M2 | KIT CAMPESTRE',
        style: {
          bg: 'purple-2',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vq27?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 7,
        name: 'EUCALIPTO 90M2 | KIT FRESCO',
        style: {
          bg: 'purple-3',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vq28?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 8,
        name: 'EUCALIPTO 90M2 | KIT MODERNO',
        style: {
          bg: 'purple-3',
          color: 'menu-item-text'
        }
      },
      {
        url: '7vqw2?fs=1&vr=1&thumbs=1&hideinst=1&chromeless=1&logo=-1',
        source: 9,
        name: 'EUCALIPTO 90M2 | KIT CAMPESTRE',
        style: {
          bg: 'purple-3',
          color: 'menu-item-text'
        }
      },
      {
        url: "collection/7k4QX?fs=1&vr=1&thumbs=1&info=0&logo=-1",
        source: 0,
        name: 'URBANISMO Y PARQUES',
        style: {
          bg: 'green-1',
          color: 'menu-item-text'
        }
      }
    ]
  }),
  components: {
    Menu,
    TourFrame
  },
  methods: {
    changeTourSource(newSource) {
      this.linkStr = newSource;
    }
  }
}
</script>